import { SEVERITY } from "helpers/utils.js";
import {
  GET_DEVICE_INFO,
  GET_DEVICE_INFO_SUCCESS,
  GET_DEVICE_INFO_FAIL,
  GET_DEVICE_INFO_BY_ID_SUCCESS,
  ADD_NEW_DEVICE_INFO,
  ADD_NEW_DEVICE_INFO_SUCCESS,
  UPDATE_DEVICE_INFO,
  UPDATE_DEVICE_INFO_SUCCESS,
  DELETE_DEVICE_INFO,
  DELETE_DEVICE_INFO_SUCCESS,
  DEVICE_INFO_CLEAR_NOTIFY,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const deviceInfo = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_NEW_DEVICE_INFO:
    case UPDATE_DEVICE_INFO:
    case DELETE_DEVICE_INFO:
    case GET_DEVICE_INFO:
      return {
        ...state,
        loading: true,
      };
    case GET_DEVICE_INFO_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_DEVICE_INFO_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
        loading: false,
      };

    case ADD_NEW_DEVICE_INFO_SUCCESS:
      return {
        ...state,
        message: {
          title: "Delivery Order",
          text: "Delivery Order has been added successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case UPDATE_DEVICE_INFO_SUCCESS:
      return {
        ...state,
        message: {
          title: "Delivery Order",
          text: "Delivery Order has been updated successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case DELETE_DEVICE_INFO_SUCCESS:
      return {
        ...state,
        message: {
          title: "Delivery Order",
          text: "Delivery Order has been deleted successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case GET_DEVICE_INFO_FAIL:
      return {
        ...state,
        error: payload,
      };
    case DEVICE_INFO_CLEAR_NOTIFY:
      return {
        ...state,
        message: null,
      };
    default:
      return state;
  }
};

export default deviceInfo;
